import { ReactElement } from 'react';

import { Claude } from '@/components/SvgIcons/Technologies';
import AfterEffects from '@/components/SvgIcons/Technologies/AfterEffects';
import Aws from '@/components/SvgIcons/Technologies/Aws';
import Figma from '@/components/SvgIcons/Technologies/Figma';
import Illustrator from '@/components/SvgIcons/Technologies/Illustrator';
import Java from '@/components/SvgIcons/Technologies/Java';
import Jira from '@/components/SvgIcons/Technologies/Jira';
import NextIcon from '@/components/SvgIcons/Technologies/NextIcon';
import Photoshop from '@/components/SvgIcons/Technologies/Photoshop';
import ReactBlue from '@/components/SvgIcons/Technologies/ReactBlue';
import Slack from '@/components/SvgIcons/Technologies/Slack';
import Vercel from '@/components/SvgIcons/Technologies/Vercel';
import Webflow from '@/components/SvgIcons/Technologies/Webflow';
import WordPress from '@/components/SvgIcons/Technologies/WordPress';

export type FeatureStackItem =
  | 'After Effects'
  | 'AWS'
  | 'Claude'
  | 'FigJam'
  | 'Figma'
  | 'Illustrator'
  | 'Java'
  | 'Jira'
  | 'Next.js'
  | 'Photoshop'
  | 'React'
  | 'Slack'
  | 'Vercel'
  | 'Webflow'
  | 'WordPress';

interface FeatureStackConfig {
  icon: ReactElement;
  label: string;
}

const featureStackConfig: Record<FeatureStackItem, FeatureStackConfig> = {
  'After Effects': { icon: <AfterEffects />, label: 'After Effects' },
  'Next.js': { icon: <NextIcon />, label: 'Next.js' },
  AWS: { icon: <Aws isDark />, label: 'Amazon Web Services' },
  Claude: { icon: <Claude isDark />, label: 'Claude' },
  FigJam: { icon: <Figma />, label: 'FigJam' },
  Figma: { icon: <Figma />, label: 'Figma' },
  Illustrator: { icon: <Illustrator />, label: 'Illustrator' },
  Java: { icon: <Java />, label: 'Java' },
  Jira: { icon: <Jira />, label: 'Jira' },
  Photoshop: { icon: <Photoshop />, label: 'Photoshop' },
  React: { icon: <ReactBlue />, label: 'React' },
  Slack: { icon: <Slack />, label: 'Slack' },
  Vercel: { icon: <Vercel isDark />, label: 'Vercel' },
  Webflow: { icon: <Webflow isDark />, label: 'Webflow' },
  WordPress: { icon: <WordPress />, label: 'WordPress' },
};

export const getFeatureStackIcon = (item: FeatureStackItem): ReactElement => featureStackConfig[item].icon;

export const getFeatureStackLabel = (item: FeatureStackItem): string => featureStackConfig[item].label;
